<template>
    <div>
      <CguComponent />
    </div>
  </template>
  
  <script>
  import CguComponent from '@/components/CguComponent.vue';
  
  export default {
    components: {
        CguComponent
    }
  }
  </script>
  